import React, { PureComponent } from 'react';

import DateBox from 'devextreme-react/date-box';

import CoreUtils from '../utils/CoreUtils';
import TimeUtils from '../utils/TimeUtils';

export default class TimeSpanEditor extends PureComponent {
  constructor(props) {
    super(props);

    this.onControlValueListener = this.onControlValueChanged.bind(this);
  }

  render() {
    return (
      <DateBox
        className="pwx-timespan-editor"
        disabled={this.props.disabled}
        displayFormat="H:mm:ss"
        height="26"
        invalidDateMessage="Value must be a time duration in the format of H:MM:SS."
        name={this.props.name}
        type="time"
        onValueChanged={this.onControlValueListener}
        showDropDownButton={false}
        value={TimeUtils.createPlaceholderTime(this.props.value)}
        width={this.props.width}
      />
    );
  }

  onControlValueChanged(event) {
    var value = TimeUtils.parseTimeFromDate(event.value);
    if (CoreUtils.isDefinedAndNotNull(this.props.postEditFilter))
      value = this.props.postEditFilter(value);

    if (CoreUtils.isDefinedAndNotNull(this.props.onValueChanged))
      this.props.onValueChanged(this.props.name, value);
  }
}